export default (data) => {
  return {
    'event': data?.event,
    'funnel_name': data?.funnel,
    'sub_funnel_name': data?.sub_funnel,
  };
};